/* Brain2Canvas — animiertes Wellen-Mesh (Canvas). Dezent, langsam, performant.
   Einsetzen: <canvas class="meshbg"></canvas> + <script src="meshbg.js"></script>.
   Optionen am Element: data-color (Linienfarbe), data-opacity. */
(function () {
  function init(cv) {
    var ctx = cv.getContext('2d');
    var color = cv.getAttribute('data-color') || 'rgba(157,161,202,.55)';
    var op = parseFloat(cv.getAttribute('data-opacity') || '1');
    var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    var GAP = 34;            // Rasterabstand
    var w, h, cols, rows, t = 0, raf;
    // Cursor-Interaktion (nur Desktop / feiner Zeiger)
    var interactive = matchMedia('(min-width:960px) and (pointer:fine)').matches && !reduce;
    var mx = -9999, my = -9999, R = 150, PUSH = 26;

    function resize() {
      var r = cv.getBoundingClientRect();
      var dpr = Math.min(devicePixelRatio || 1, 2);
      w = r.width; h = r.height;
      cv.width = w * dpr; cv.height = h * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      cols = Math.ceil(w / GAP) + 2;
      rows = Math.ceil(h / GAP) + 2;
    }

    // Verzerrung: Summe weicher Sinuswellen + Cursor-Beule
    function warp(x, y, time) {
      var dx = Math.sin(y * 0.012 + time * 0.6) * 16
             + Math.sin((x * 0.6 + y) * 0.006 + time * 0.4) * 12;
      var dy = Math.cos(x * 0.012 + time * 0.5) * 16
             + Math.cos((y * 0.6 + x) * 0.006 + time * 0.45) * 12;
      if (interactive) {
        var ddx = x - mx, ddy = y - my, d2 = ddx * ddx + ddy * ddy;
        if (d2 < R * R) {
          var d = Math.sqrt(d2) || 1, f = (1 - d / R), push = f * f * PUSH;
          dx += (ddx / d) * push; dy += (ddy / d) * push;
        }
      }
      return [x + dx, y + dy];
    }

    function draw() {
      ctx.clearRect(0, 0, w, h);
      ctx.lineWidth = 1;
      ctx.strokeStyle = color;
      ctx.globalAlpha = op;
      var x, y, p;
      // horizontale Linien
      for (var j = 0; j < rows; j++) {
        ctx.beginPath();
        for (var i = 0; i < cols; i++) {
          x = i * GAP - GAP; y = j * GAP - GAP;
          p = warp(x, y, t);
          i === 0 ? ctx.moveTo(p[0], p[1]) : ctx.lineTo(p[0], p[1]);
        }
        ctx.stroke();
      }
      // vertikale Linien
      for (var ii = 0; ii < cols; ii++) {
        ctx.beginPath();
        for (var jj = 0; jj < rows; jj++) {
          x = ii * GAP - GAP; y = jj * GAP - GAP;
          p = warp(x, y, t);
          jj === 0 ? ctx.moveTo(p[0], p[1]) : ctx.lineTo(p[0], p[1]);
        }
        ctx.stroke();
      }
      ctx.globalAlpha = 1;
    }

    function loop() { t += 0.006; draw(); raf = requestAnimationFrame(loop); }

    resize(); draw();
    addEventListener('resize', function () { resize(); if (reduce) draw(); });
    if (interactive) {
      addEventListener('pointermove', function (ev) {
        var r = cv.getBoundingClientRect();
        mx = ev.clientX - r.left; my = ev.clientY - r.top;
      }, { passive: true });
    }
    if (!reduce) loop();
    // pausieren, wenn off-screen (spart Akku)
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (reduce) return;
          if (e.isIntersecting) { if (!raf) loop(); }
          else { cancelAnimationFrame(raf); raf = null; }
        });
      }, { threshold: 0 }).observe(cv);
    }
  }

  function boot() { document.querySelectorAll('canvas.meshbg').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
